import { render, staticRenderFns } from "./AuthorArticle.vue?vue&type=template&id=69db43ce&"
import script from "./AuthorArticle.vue?vue&type=script&lang=js&"
export * from "./AuthorArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports